import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import styles from './peddingMedicalTreatment.module.css'
import moment from 'moment'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimples,
} from '../../../models/datetime'
import {
  CaretDownFilled,
  CloseOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import FileUpload from '../../../compnents/file/FileUpload'
import { unwrapResult } from '@reduxjs/toolkit'
import { getUrl } from '../../treatment/diagnosis/diagnosisSlice'
import { StationCategory } from '../../../models/user'
import { getUsersInDepartmentAsync } from '../../completion/completionSlice'
import { selectTenantName, selectUserId } from '../../../app/applicationSlice'
import { defaultXianBingListAsync } from '../../treatment/tcmCases/tcmCasesSlice'
import { SettingTreatmentParts } from '../../examinetreat/settingTreatmentParts'
import { EditableList } from '../../../compnents/list/EditableList'
import { ExcuteRecordColumns } from './column'
import { getBatchExecuteDetail, getPeddingMedicalTreatmentRecordDetail } from './peddingMedicalTreatmentSlice'
import { getExcuteDetailAsync, updateExcuteDetailAsync } from '../toBeCompletedTreatment/toBeCompletedTreatmentSlice'

const { Option } = Select

export const ExcuteModal = (props: {
  id?: any
  edit?: boolean
  treatmentServiceName?: any
  recipeId?: any
  recipeItemId?: any
  singleState: boolean
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
  acupointList?:any
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [numFlag, setNumFlag] = useState(false)

  const [changeId, setChangeId] = useState('')

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detailList, setDetailList] = useState<any>()

  const [executeNum, setExecuteNum] = useState(0)

  const [assistantList, setAssistantList] = useState<any>()

  const [treatmentPartsList, setTreatmentPartsList] = useState<any>()

  const [editTreatmentParts, setEditTreatmentParts] = useState(false)

  const tenantName = useSelector(selectTenantName)

  const [checked, setChecked] = useState(false)

  const UserId = useSelector(selectUserId)

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const firstLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }

  useEffect(() => {
    // 默认回填
    if (props.isModalVisible) {
      form.setFieldsValue({
        executeTime: moment(),
      })
    } else {
      form.resetFields()
      setDetailList([])
      setFileList([])
    }
  }, [props.isModalVisible])

  useEffect(() => {
    // 获取执行人
    if (props.isModalVisible) {
      if (!props?.edit) {
        getZXRList([UserId?.toString()])
      }
    }
  }, [props.isModalVisible])

  const getZXRList = (operatorIds?: string[]) => {
    dispatch(
      getUsersInDepartmentAsync({
        departmentId: '',
        stationCategory: StationCategory.DoctorOrPharmacist,
        multyStationCategory: '0,1,7',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setAssistantList(res)
        const operatorId = res?.find((v: any) => v?.id == UserId.toString())?.id ? [UserId.toString()] : []
        if (!props?.edit) {
          form.setFieldsValue({
            operatorId: operatorId,
          })
        } else {
          const validOperatorIds: any = operatorIds?.filter((id: string) =>
            res?.some((item: any) => item?.id?.toString() === id)
          )
          form.setFieldsValue({
            operatorId: validOperatorIds?.length > 0 ? validOperatorIds : operatorId,
          })
        }
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      setNumFlag(false)
      setChangeId('')
      const json =
        localStorage.getItem('medicalSationChecked') == 'true' ? true : false
      setChecked(json)
    }
  }, [props.isModalVisible])

  useEffect(() => {
    // 获取展示列表格
    const params = props?.singleState ? {
      recipeId: props?.recipeId,
      recipeItemId: props?.recipeItemId
    } : {
      recipeId: props?.recipeId,
    }
    if (props.isModalVisible) {
      // 编辑
      if (props?.edit) {
        dispatch(getExcuteDetailAsync(props.id))
          .then(unwrapResult)
          .then((v: any) => {
            const data: any = {
              operatorId: v?.operatorId
                ? v?.operatorId?.split(',')?.map((v: any) => v?.toString())
                : [UserId?.toString()],
            }
            form.setFieldsValue({
              ...v,
              treatmentParts: v?.treatmentParts
                ? v?.treatmentParts?.split(',')
                : [],
              executeTime: v.executeTime ? moment(v.executeTime) : moment(),
              executeEndTime: v.executeEndTime ? moment(v.executeEndTime) : null,
              executeNum: v?.remainNum >= 1 ? 1 : (v?.remainNum).toFixed(1),
              operatorId: []
            })
            getZXRList(v?.operatorId?.split(',')?.map((v: any) => v?.toString()))

            const list = [{
              ...v,
              ...data,
              executeOldNum: v?.executeNum || 0,
              treatmentServiceName: props?.treatmentServiceName,
              totalNumberExecution: v?.totalExecuteNum || 0,
            }]
            setDetailList(list)
            setExecuteNum(v?.executeNum || 0)
            setFileList(
              v?.attachmentFile
                ? v?.attachmentFile?.split(',')?.map((v: any) => {
                  return ({
                    name: v.split('@')[0],
                    uid: v.split('@')[1],
                    url: v.split('@')[2],
                  } as unknown) as UploadFile
                })
                : []
            )
          })
      } else {
        dispatch(
          getPeddingMedicalTreatmentRecordDetail({
            ...params,
          })
        )
          .then(unwrapResult)
          .then((res: any) => {
            // 初始化每个项目的执行次数为1
            const initializedList = res?.map((item: any) => ({
              ...item,
              executeNum: item?.remainNum >= 1 ? 1 : (item?.remainNum).toFixed(1),
            }))
            setDetailList(initializedList)
          })
      }

    }
  }, [props.isModalVisible])


  // 部位
  useEffect(() => {
    if (props.isModalVisible) {
      getBWList()
    }
  }, [props?.isModalVisible])

  const getBWList = () => {
    dispatch(defaultXianBingListAsync(2))
      .then(unwrapResult)
      .then((res) => {
        setTreatmentPartsList(res)
      })
  }

  return (
    <Modal
      width={1000}
      title={props?.edit ? '编辑' : (props?.singleState ? '单个执行' : '批量执行')}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <div style={{ height: '500px', overflowY: 'auto', marginBottom: '16px', paddingRight: '16px' }}>
        <Form
          className={styles.form}
          name='basic'
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            if (props?.edit) {
              const invalidItems = detailList?.filter((v: any) => {
                const executeNums = Number(v?.executeNum)
                const elseNum: any = (Number(v?.num) - (Number(executeNum || 0) + Number(v?.remainNum || 0)))?.toFixed(1)
                const remainNum: any = ((((Number(v?.num) - Number(elseNum)) as any)?.toFixed(1)) - Number(executeNums || 0))?.toFixed(1)
                // 正则
                const intReg = new RegExp(/^[0-9]\d*(\.\d)?$/)
                return !intReg.test(String(executeNums)) || Number(remainNum) < 0
              })
              if (invalidItems?.length) {
                notification.warning({
                  message: '提示',
                  description: invalidItems.map((item: any) =>
                    `【${item.treatmentServiceName}】执行次数支持小数点后一位,且不超过剩余次数`
                  ).join('；'),
                })
                return
              }
            } else {
              const invalidItems = detailList?.filter((v: any) => {
                const executeNum = Number(v?.executeNum)
                const remainNum = Number(v?.remainNum)
                // 正则
                const intReg = new RegExp(/^[0-9]\d*(\.\d)?$/)
                return !intReg.test(String(executeNum)) || executeNum > remainNum
              })
              if (invalidItems?.length) {
                notification.warning({
                  message: '提示',
                  description: invalidItems.map((item: any) =>
                    `【${item.treatmentServiceName}】执行次数支持小数点后一位,且不超过剩余次数`
                  ).join('；'),
                })
                return
              }
            }

            setConfirmLoading(true)
            const data = assistantList.filter((item: any) =>
              values.operatorId.includes(item.id)
            )
            const operatorName = data.map((item: any) => item.name)
            const momentType = props?.edit
              ? DateTimeFormat
              : DateTimeFormatSimples
            const params =
              detailList?.map((v: any) => {
                return {
                  ...v,
                  ...values,
                  treatmentParts: v?.treatmentParts || '',
                  executeNum: v?.executeNum ? v?.executeNum : '',
                  operatorName: operatorName?.length
                    ? operatorName?.join(',')
                    : '',
                  operatorId: values?.operatorId?.length
                    ? values?.operatorId?.join(',')
                    : '',
                  executeTime: values?.executeTime
                    ? moment(values?.executeTime).format(momentType)
                    : moment().format(momentType),
                  executeEndTime: values?.executeEndTime
                    ? moment(values?.executeEndTime).format(momentType)
                    : '',
                  attachmentFile: fileList
                    ?.map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
                    ?.join(','),
                  smsFlag: checked,
                }
              })
            if (props?.edit) {
              dispatch(
                updateExcuteDetailAsync(params?.[0])
              )
                .then(unwrapResult)
                .then(() => {
                  notification.success({
                    message: '操作成功',
                  })
                  props?.onOk()
                })
                .catch(() => {
                  props.onCancel()
                })
                .finally(() => {
                  setConfirmLoading(false)
                })
            } else {
              dispatch(getBatchExecuteDetail(
                params,
              ))
                .then(unwrapResult)
                .then((v) => {
                  notification.success({
                    message: '操作成功',
                  })
                  props.onOk()
                })
                .catch((err) => {
                  props.onCancel()
                })
                .finally(() => {
                  setConfirmLoading(false)
                })
            }

          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                name='operatorId'
                label='执行人：'
                rules={[{ required: true, message: '请选择执行人' }]}
              >
                <Select
                  mode='multiple'
                  placeholder='执行人'
                  allowClear
                >
                  {assistantList?.map((v: any) => (
                    <Option key={v.id?.toString()} value={v.id?.toString()}>
                      {v.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                required
                name='executeTime'
                label='执行开始时间'
                rules={[{ required: true, message: '请选择本次执行开始时间' }]}
              >
                <DatePicker
                  showTime
                  format='YYYY/MM/DD HH:mm'
                  style={{
                    width: '100%',
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} name='executeEndTime' label='执行结束时间'>
                <DatePicker
                  showTime
                  format='YYYY/MM/DD HH:mm'
                  style={{
                    width: '100%',
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                {...firstLayout}
                name='remark'
                label='备注：'
              >
                <Input.TextArea showCount maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name='attachmentFile' label='附件'
                {...firstLayout}>
                <FileUpload
                  count={(fileList && fileList.length) || 0}
                  files={fileList}
                  onUpload={(v, i) => {
                    setFileList([
                      ...fileList,
                      {
                        uid: v.uid,
                        size: v.size,
                        name: v.name,
                        type: v.type,
                        originFileObj: {} as RcFile,
                        url: i,
                      },
                    ])
                  }}
                >
                  <Button icon={<PlusOutlined />}>上传附件</Button>
                </FileUpload>
                {fileList &&
                  fileList.map((item) => (
                    <Row
                      gutter={24}
                      key={item.uid}
                      style={{
                        padding: '10px',
                        width: '300px',
                      }}
                    >
                      <Col flex={1}>
                        <span
                          style={{
                            display: 'inline-block',
                            maxWidth: '60px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            verticalAlign: 'middle',
                          }}
                        >
                          {item.name.split('.')[0]}
                        </span>
                        <span
                          style={{
                            verticalAlign: 'middle',
                          }}
                        >
                          .{item.name.split('.')[1]}
                        </span>
                      </Col>
                      <Col span={6}>
                        <a
                          onClick={() => {
                            dispatch(getUrl({ fileName: item.url }))
                              .then(unwrapResult)
                              .then((v: any) => {
                                const proxy =
                                  window.location.origin.indexOf(
                                    'his.develop.hydhis.com'
                                  ) >= 0
                                    ? '/proxyToOssDevPrivate'
                                    : window.location.origin.indexOf(
                                      'his.test.hydhis.com'
                                    ) >= 0
                                      ? '/proxyToOssTestPrivate'
                                      : window.location.origin.indexOf('hydhis.cn') >= 0
                                        ? '/proxyToOssProdPrivate'
                                        : '/proxyToOssProdPrivate'
                                const url =
                                  (window.location.origin?.includes('localhost')
                                    ? 'http://hydhis.cn'
                                    : window.location.origin) +
                                  proxy +
                                  v
                                window.open(url, '_blank')
                              })
                          }}
                        >
                          查看
                        </a>
                      </Col>
                      <Col span={6}>
                        <CloseOutlined
                          onClick={() => {
                            //  e.stopPropagation();
                            setFileList(() =>
                              fileList.filter((ite) => ite.uid !== item.uid)
                            )
                          }}
                        />
                      </Col>
                    </Row>
                  ))}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col
              span={24}
              style={{ lineHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', color: '#027AFF' }}

            >
              <SettingOutlined onClick={() => setEditTreatmentParts(true)} />
              <div style={{ marginLeft: '6px', cursor: 'pointer' }} onClick={() => setEditTreatmentParts(true)}>部位设置</div>
            </Col>
            <Col span={24}>
              <EditableList
                bordered
                pagination={false}
                page={{
                  items: detailList || [],
                  current: 1,
                  size: 10,
                  total: 0,
                }}
                columns={ExcuteRecordColumns((t, v, e) => {
                  if (t === 'changeExecuteNum') {
                    setDetailList(detailList?.map((item: any) => ({
                      ...item,
                      executeNum: v?.id == item.id ? e : item.executeNum,
                    })))
                    setChangeId(v.id)
                    setNumFlag(true)
                  } else if (t === 'changeTreatmentParts') {
                    setDetailList(detailList?.map((item: any) => ({
                      ...item,
                      treatmentParts: v?.id == item.id ? (e ? e?.join(',') : '') : item.treatmentParts,
                    })))
                  }
                }, treatmentPartsList, props?.edit,props?.acupointList)} />
            </Col>
          </Row>
        </Form>
      </div>
      <Row>
        <div style={{ paddingLeft: '10px', marginBottom: '10px' }}>
          <Checkbox
            checked={checked}
            onChange={() => {
              setChecked(!checked)
              localStorage.setItem(
                'medicalSationChecked',
                JSON.stringify(!checked)
              )
            }}
          >
            发送短信 {tenantName?.split('-')?.[0]} 温馨提示：
            {detailList?.map((item: any) => {
              const executeNum: any = (Number(item.totalNumberExecution) + Number(item.executeNum))?.toFixed(1)
              const remainNum: any = (Number(item?.num) - Number(executeNum || 0))?.toFixed(1)
              const elseNum: any = (Number(item?.num) - (Number(item.executeOldNum || 0) + Number(item?.remainNum || 0)))?.toFixed(1)
              return props?.edit ?
                `您所办理的${item.treatmentServiceName}疗程，完成${item?.executeNum || 0}次调理，剩余${(elseNum == 0 ? Number(item?.num) : Number(elseNum)) - Number(item?.executeNum || 0)}次。` :
                `您所办理的${item.treatmentServiceName}疗程，完成${executeNum}次调理，剩余${remainNum}次。`
            })}
          </Checkbox>
        </div>
      </Row>
      <Row gutter={20}>
        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            style={{ marginRight: '10px' }}
            onClick={() => {
              props?.onCancel && props?.onCancel()
            }}>
            取消
          </Button>
          <Button
            loading={confirmLoading}
            type='primary'
            onClick={() => {
              form.submit()
            }}>
            {props?.edit ? '编辑' : '确认执行'}
          </Button>
        </Col>
      </Row>
      <SettingTreatmentParts
        isSettingTreatmentParts={editTreatmentParts}
        onCancel={() => {
          setEditTreatmentParts(false)
          getBWList()
        }}
        onOk={() => {
          setEditTreatmentParts(false)
          getBWList()
        }}
        refresh={() => {
          return
        }}
      />
    </Modal >
  )
}